import PureSimilarCompanies from './PureSimilarCompanies';
import useNextStepInfo from './useNextStepInfo';
import type { CompanyReportSection } from '@/pages/CompanyReport/useSection';
import { getGridViewOptionIdBySection } from './utils';

interface Props {
  section: CompanyReportSection;
  title: string;
}

const NextStep = ({ section, title }: Props) => {
  const gridViewOptionId = getGridViewOptionIdBySection(section);

  const {
    companies,
    gridRulesStatus,
    gridCompaniesStatus,
    market,
    industry,
    companyId,
  } = useNextStepInfo({
    gridViewOptionId,
    section,
  });

  const isLoading =
    gridRulesStatus === 'pending' || gridCompaniesStatus === 'pending';
  const isErrored =
    gridRulesStatus === 'error' || gridCompaniesStatus === 'error';

  return (
    <PureSimilarCompanies
      title={title}
      companies={companies}
      section={section}
      market={market}
      industry={industry}
      gridViewOptionId={gridViewOptionId}
      isLoading={isLoading}
      isErrored={isErrored}
      companyId={companyId}
    />
  );
};

export default NextStep;
